import { createAsyncThunk } from '@reduxjs/toolkit';
import type { ParticipantDetailedResultsData } from 'features/quizzes/types';
import { requestDetailedQuizResultsService } from 'features/quizzes/services';

export const requestDetailedQuizResults = createAsyncThunk<
  ParticipantDetailedResultsData,
  { quizId: string; participantId: string },
  { rejectValue: string }
>('quizzes/requestDetailedQuizResults', async ({ quizId, participantId }, { rejectWithValue }) => {
  try {
    return await requestDetailedQuizResultsService(quizId, participantId);
  } catch (error) {
    return rejectWithValue('Failed to fetch detailed quiz results');
  }
});
